import { Environment } from './environment.model';
import { appVersion } from './app-version';
import { supportedLanguages } from './supported-languages';
import { roles } from './roles';

export const environment: Environment = {
    production: true,
    version: appVersion,
    instana: true,
    app: {
        defaultLanguage: 'de-DE',
        supportedLanguages,
        roles,
        multiValenceForbiddenSalesOrgs: ['6000'],
        contractMinDateCurrentYearSalesOrg: ['6200'],
    },
    auth: {
        appId: 'service-configurator',
        baseUrl: 'https://api-integration.viessmann-climatesolutions.com',
        usersUrl: 'https://api-integration.viessmann-climatesolutions.com/users/v1/users/me',
        registerBaseUrl: 'https://account-integration.viessmann-climatesolutions.com',
    },
    http: {
        apiBaseUrl: 'https://api-integration.viessmann-climatesolutions.com/backend/service-configurator/v2/',
        translations:
            'https://api-integration.viessmann-climatesolutions.com/translations/v2/phraseapp-proxy/projects/9209f7dba36cf4da6cf12ca1b499cdcb/locales/',
        dswTranslations:
            'https://api-integration.viessmann-climatesolutions.com/translations/v2/phraseapp-proxy/projects/ec38b083a23c58c604a49d7f443dd7f2/locales/',
        users: 'https://api-integration.viessmann-climatesolutions.com/users/v1/users/',
        equipment: {
            search: {
                employee: 'https://fiori-test.viessmann-climatesolutions.com/fiori#ZCS_EQUI_SEARCH_BY_ADDRESS2-display',
                customer:
                    'https://api-integration.viessmann-climatesolutions.com/service-and-maintenance/heating-systems-overview/v1/b2b/heating-systems',
                consumer:
                    'https://api-integration.viessmann-climatesolutions.com/service-and-maintenance/heating-systems-overview/v1/b2c/heating-systems',
            },
            change: {
                employee:
                    'https://fiori-test.viessmann-climatesolutions.com/fiori#ZCS_EQUI_MASTER_DATA_SHEET-display?equipment=',
                customer: 'https://heating-system-registration-b2b-integration.viessmann-climatesolutions.com/open/',
            },
        },
        shopUrl: 'https://shop-test.viessmann-climatesolutions.com/',
        statusPage: 'https://api-integration.viessmann-climatesolutions.com/status/v1/apps/kj88dx0lbj9c/summary',
        checkoutUrl: 'https://checkout-integration.viessmann-climatesolutions.com',
        faq: {
            customer: {
                '0500': 'https://partnerportal.viessmann-climatesolutions.com/de/de/support/faq/service-configurator.html',
            },
            endcustomer: {
                '0500': 'https://www.viessmann.de/de/kontakt/anfragen/vertragsangebot-faq.html',
            },
            default: 'https://support.viessmann-climatesolutions.com/?page=1&pageSize=8',
        },
        companyUrl: 'https://api-integration.viessmann-climatesolutions.com/company/v3/companies/',
        quotation: 'https://api-integration.viessmann-climatesolutions.com/quotation/v1/',
        pim: 'https://api-integration.viessmann-climatesolutions.com/backend/pim/v1/',
        configuration: 'https://api-integration.viessmann-climatesolutions.com/backend/configuration/v1/',
    },
    configit: {
        imageUrl:
            'https://api-integration.viessmann-climatesolutions.com/backend/service-configurator/v2/configuration/images',
        languages: ['de'],
        salesAreaName: 'Germany',
        usage: '5',
        plant: '0500',
    },
    quest: {
        context: 'quest',
        project: 'ServiceConfig',
    },
};
